
import React, {useState,useEffect,useCallback} from 'react'
import UpdateRegistrationUseForm from './UpdateRegistrationUseForm';
import Modal from '../../Modal/Modal';
import  "./UpdateRegistration.css";
import * as Constants from '../../../common/Constants';
// import Modal from '@material-ui/core/Modal';
import dataServices from "../../../common/dataServices";
import ContactUs from '../ContactUs';

const UpdateRegistrationForm = React.memo(props =>{
   const stateSchema = {
     Fields:{
          Title: {value: 'בקשת הצטרפות ניוזלטר מדף הבית' ,error:''},
          MODFirstName: { value: '',error:'' }
          ,MODAdress:{value:'', error:''}
          ,MODEMail: { value: '', error:''}
     },
    MailTo:'',
   // type: Constants.CreateNewItemNewsLetter,
   //the key in webconfig
   type: 4
   , webUrl: props.mainURL
    
  };

  const [showModal,setShowModal] = useState(false);
  const [isSucc,setIsSucc] = useState(false);
  const [loading,setLoading]= useState(false);
  const [firstName,setFirstName]= useState('');

  // Disable button in initial render.
  useEffect(() => {
    setShowModal(false);
  }, []);


// Define your validationStateSchema
  // Note: validationStateSchema and stateSchema property
  // should be the same in-order validation works!
  const validationStateSchema = {
    Title: { },
    MODFirstName: {
      required: true,
      validator: {
        regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
       error: CreateDicLanguages().MODFirstNameError,
      },
    },
    
    MODAdress:{
      required: true,
       validator: {
         //regEx: /^[a-zA-Z\u0590-\u05ff]+$/,
         regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
         error:  CreateDicLanguages().MODAdressError,
      },
    },
    MODPhoneNumber: {
      required: false,
      validator: {
        regEx:/^\+?(972|0)?(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/,
        error: CreateDicLanguages().MODPhoneNumberError,
      },
    },
    MODEMail: {    
      required: true,
        validator: {
          regEx:  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          error: CreateDicLanguages().MODEMailError ,
        },
      },

  };

   function onSubmitForm(state) { 
    
    setLoading(true);
    setFirstName(state.Fields.MODFirstName.value);
    const res =  dataServices.setItems(state).then(response=>{
    //  debugger;
      !!response.data.ErrorMessage ? 
          setIsSucc(false)
        : setIsSucc(true);
        
          setShowModal(true); 
          setLoading(false);
      }).catch((error)=>
      {
          setIsSucc(false);
          setShowModal(true);
          setLoading(false);
      });
  };
  


  function handleOnClose (){
      setShowModal(false);
    }
    function CreateDicLanguages(){
      var dic ={};
      dic.he={};
      dic.en={};
      dic.ar={};
      dic.he["MODFirstName"]="שם מלא";
      dic.he["MODPhoneNumber"] ="טלפון";
      dic.he["MODAdress"] ="ארגון";
      dic.he["MODEMail"]='דוא"ל';
      dic.he["submit"] = "הרשמה";
      dic.he["ContactUsTitle"] = Constants.ContactUsTitleHE;
      dic.he["MODFirstNameError"]=  'פורמט שם שגוי';
      dic.he["MODAdressError"]=  'פורמט שם אירגון שגוי';
      dic.he["MODPhoneNumberError"]=  'מספר טלפון שגוי';
      dic.he["MODEMailError"]=  'מייל שגוי';
      dic.he["MODLegendText"]=  'כניסה לרשימת דיוור';
      
      dic.ar["MODFirstName"]="الاسم الكامل";
      dic.ar["MODPhoneNumber"]= "رقم الهاتف";
      dic.ar["MODAdress"] ="المنظمة";
      dic.ar["MODEMail"] = "البريد الإلكتروني";
      dic.ar["submit"] = "التسجيل";
      dic.ar["ContactUsTitle"] = 'يرجى ترك تفاصيلك لنعاود الاتصال بك';
      dic.ar["MODFirstNameError"]=  'تنسيق اسم غير صالح';
      dic.ar["MODAdressError"]=  'تنسيق اسم منظمة غير صالح';
      dic.ar["MODPhoneNumberError"]=  'رقم هاتف غير صالح';
      dic.ar["MODEMailError"]=  'تنسيق يريد إلكتروني غير صالح';
      dic.he["MODLegendText"]=  'newsletter registration';

      dic.en["MODFirstName"]="Full name";
      dic.en["MODPhoneNumber"]= "Mobile Phone";
      dic.en["MODAdress"] ="Organization";
      dic.en["MODEMail"] = "E-mail";
      dic.en["submit"] = "Register";
      dic.en["ContactUsTitle"] = Constants.ContactUsTitleEN;
      dic.en["MODFirstNameError"]=  'Invalid first name format';
      dic.en["MODAdressError"]=  'Invalid organization name format.';
      dic.en["MODPhoneNumberError"]=  'Invalid phone format';
      dic.en["MODEMailError"]=  'Invalid Mail Format';
      dic.he["MODLegendText"]=  'newsletter registration';
      if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/he')> -1)
      {
        return dic.he;
      }
      else if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/ar')> -1){
        return dic.ar;
      }
      else {
        return dic.en;
      }
    
    }

const { state, handleOnChange, handleOnSubmit, disable } = UpdateRegistrationUseForm(
    stateSchema,
    validationStateSchema,
    onSubmitForm,
  );
const errorStyle = {
    color: '#ff6363'
    ,fontSize: '16px'
    ,position:'absolute'
    ,marginTop: '3px'
    ,border: 'solid thin red'
   
  };

  /* Create dic for various cultures*/
return (
  // className={'col-12 col-lg-12'}
    <div className="updateregistration">
       {loading &&
       <div className="centerIcon">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
        }
        <Modal show={showModal} isSucc={isSucc}  onClose={handleOnClose} data={firstName}/>
        {/* col-lg-12 */}
        <fieldset legend={CreateDicLanguages().MODLegendText}  tabIndex="0"  role="newsletter-group" className="col-12">
      <form onSubmit={handleOnSubmit} className={'registraion-form col-lg-12'} role="form">
              
     
      <div className="visible-sm col-lg-1"></div>
      {/*  */}
        <div className="fieldDiv col-6 col-lg-3">
       
            <input
            id={'newsletter_form_firstname'}
              type="text"
              name="MODFirstName"
              className={state.Fields["MODFirstName"].error && 'error-border'}
              value={state.Fields["MODFirstName"].value}
              onChange={handleOnChange}
              placeholder={CreateDicLanguages().MODFirstName +'*' }
              title={CreateDicLanguages().MODFirstName}
              aria-label={CreateDicLanguages().MODFirstName}
              tabIndex="0" 

              //aria-labeledby={CreateDicLanguages().MODFirstName}
              
              aria-describedby={"error_newsletter_form_firstname"}
              aria-invalid={state.Fields["MODFirstName"].error  ? 'true':'false'}
              aria-required={validationStateSchema["MODFirstName"].required}
            />
         
          {state.Fields["MODFirstName"].error && <p id={'error_newsletter_form_firstname'} style={errorStyle}>{state.Fields["MODFirstName"].error}</p>}
        </div>
       
         <div className="fieldDiv field-div col-6 col-lg-3">
       
            <input
            id={'newsletter_form_modaddress'} 
            className={state.Fields["MODAdress"].error && 'error-border'}
              type="text"
              name="MODAdress"
              value={state.Fields["MODAdress"].value}
              onChange={handleOnChange} 
              placeholder={CreateDicLanguages().MODAdress +'*'}

              title={CreateDicLanguages().MODAdress}
              //aria-labeledby={CreateDicLanguages().MODAdress}
              aria-label={CreateDicLanguages().MODAdress}
              tabIndex="0" 
             
              aria-describedby={"error_newsletter_form_modaddress"}
              aria-invalid={state.Fields["MODAdress"].error  ? 'true':'false'}
              aria-required={validationStateSchema["MODAdress"].required}
            />
         
          {state.Fields["MODAdress"].error && <p id={'error_newsletter_form_modaddress'} style={errorStyle}>{state.Fields["MODAdress"].error}</p>}
        </div> 
        <div className="fieldDiv col-12 col-lg-5 input-group">
          <div className={"input-group-append"}>
            <input
            id={'newsletter_form_email'} 
            className={state.Fields["MODEMail"].error && 'error-border'}
              type="email"
              name="MODEMail"
              value={state.Fields["MODEMail"].value}
              onChange={handleOnChange}
              placeholder={CreateDicLanguages().MODEMail+'*'}

              title={CreateDicLanguages().MODEMail}
              //aria-labeledby={CreateDicLanguages().MODEMail}
              aria-label={CreateDicLanguages().MODEMail}
              tabIndex="0" 
                            
              aria-describedby={"error_newsletter_form_firstname"}
              aria-invalid={state.Fields["MODEMail"].error  ? 'true':'false'}
              //aria-required={validationStateSchema["MODEmail"].required}
              aria-required={true}
            />
              {/* {state.Fields["MODEMail"].error && <p id={'error_newsletter_form_email'} style={errorStyle}>{state.Fields["MODEMail"].error}</p>} */}
        </div>
       
        <button type="submit" name="submit" tabIndex="0" role="button" text="הרשמה" value="הרשמה" disabled={disable} className="submitBut btn btn-outline-secondary banner-button">
            {CreateDicLanguages().submit} 
            {_spPageContextInfo.webServerRelativeUrl.indexOf('/en')>-1 ?<i className={'fas fa-arrow-right thin-icon'}></i> :<i className={'fas fa-arrow-left thin-icon'}></i> }
          </button>
          {state.Fields["MODEMail"].error && <p id={'error_newsletter_form_email'} style={errorStyle}>{state.Fields["MODEMail"].error}</p>}
        </div>
       
        {/* */}
      </form>
      </fieldset> 
    </div>
  );
});
export default UpdateRegistrationForm;

